import { first } from 'rxjs/operators';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TapeChartComponent } from '../tape-chart/tape-chart.component';
import { Component, OnInit } from '@angular/core';
import { AlertService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { TapeChartService } from '../tape-chart.service';
import { TapeChart } from '../tape-chart';

@Component({
    selector: 'app-tape-chart-list-cell-edit',
    templateUrl: './tape-chart-list-cell-edit.component.html',
    styleUrls: ['./tape-chart-list-cell-edit.component.css'],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class TapeChartListCellEditComponent implements OnInit {
	constructor(
		private tapeChartService: TapeChartService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private dialog: MatDialog,
	) {
		this.statuses = tapeChartService.statuses
	}



	// data
	tapeCharts: any;
	tapeChart: TapeChart;

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// forms
	formLoading = false;

	statuses: any;

	columns: any[] = [
		{ field: 'rateId', header: 'Id', width: 'auto' },
		{ field: 'name', header: 'Name', width: 'auto' },
		{ field: 'description', header: 'Description', width: 'auto' },
		{ field: 'status', header: 'Status', width: 'auto' },
	];

	ngOnInit(): void {
		try {
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'createDate', order: 0 });
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}


	/*********
	 * Cell Edit Callbacks (if using cell edit feature).
	 * Remove editMode="row" in p-table
	 * Remove <tr [pEditableRow]="tapeChart"> and just have plain <tr>
	 * Add <td [pEditableColumn]="tapeChart" [pEditableColumnField]="'name'"> for each cell <td>
	 * Update <ng-template pTemplate="body" let-tapeChart>
	 *
	 */
	onCellEditInit(event: any): void { }
	onCellEditComplete(event: any): void { this.formUpdate(event.data); }
	onCellEditCancel(): void { this.messageService.add({ severity: 'info', summary: 'Update Canceled', detail: 'No changes were saved' }); }


	/*********
	 * Row Edit Callbacks (if using row edit feature)
	 * Add editMode="row" in p-table
	 * Add <tr [pEditableRow]="tapeChart"> for the <tr>
	 * Remove <td [pEditableColumn]="tapeChart" [pEditableColumnField]="'name'"> for each cell <td>
	 * <ng-template pTemplate="body" let-tapeChart let-editing="editing" let-ri="rowIndex">
	 */
	onRowEditInit(tapeChart: TapeChart): void { }
	onRowEditSave(tapeChart: TapeChart): void { }
	onRowEditCancel(): void { this.messageService.add({ severity: 'info', summary: 'Update Canceled', detail: 'No changes were saved' }); }


	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.rateId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}


	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-tapeChart-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'createDate', order: -1 });
			}

			const pageNumber = Math.round(event.first / event.rows);
			this.tapeChartService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.datasource = res.data.reviews;
						this.recordTotal = res.page.recordTotal;
						this.tapeCharts = res.data.tapeCharts;
						console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						console.log('reviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.tapeCharts = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	getStatus() {
		return
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit(event.data);
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(tapeChart: TapeChart) {
		try {
			this.formLoading = true;
			this.tapeChartService.update(tapeChart)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.tapeCharts.map((tapeChart, i) => {
							if (tapeChart.rateId === res.data.tapeChart.rateId) {
								this.tapeCharts[i] = res.data.tapeChart;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(tapeChart: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(tapeChart));

			this.formLoading = true;
			this.tapeChartService.delete(tapeChart.rateId)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.tapeCharts.splice(this.tapeCharts.indexOf(tapeChart), 1);
						this.recordTotal = this.tapeCharts.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'TapeChart ' + tapeChart.rateId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'TapeChart ' + tapeChart.rateId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add TapeChart'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(TapeChartComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.addTapeChartCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(tapeChart: TapeChart) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			tapeChart: tapeChart,
			title: 'Edit TapeChart'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(TapeChartComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.updateTapeChartCB(data);

				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.deleteTapeChartCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addTapeChartCB(tapeChart: TapeChart) {
		console.log('Adding TapeChart: ' + JSON.stringify(tapeChart));
		// if we don't have a tapeCharts array yet...
		if (!this.tapeCharts) {
			this.tapeCharts = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.tapeCharts.unshift(tapeChart);

		// no idea what this is but it is required to update the array
		this.tapeCharts = [...this.tapeCharts];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'TapeChart ' + tapeChart.rateId + ' Added', life: 3000 });
	}

	updateTapeChartCB(tapeChart: TapeChart) {
		console.log('Updating TapeChart: ' + JSON.stringify(tapeChart));
		let itemIndex = this.tapeCharts.findIndex((item: any) => item.rateId === tapeChart.rateId);
		this.tapeCharts[itemIndex] = tapeChart;

		// no idea what this is but it is required to update the array
		this.tapeCharts = [...this.tapeCharts];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'TapeChart ' + tapeChart.rateId + ' Updated', life: 3000 });
	}

	deleteTapeChartCB(tapeChart: TapeChart) {
		console.log('Removing TapeChart: ' + tapeChart);
		this.tapeCharts.splice(this.tapeCharts.indexOf(tapeChart), 1);
		this.recordTotal = this.tapeCharts.length;

		// no idea what this is but it is required to update the array
		this.tapeCharts = [...this.tapeCharts];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'TapeChart ' + tapeChart.rateId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.tapeCharts ? this.first === (this.tapeCharts.length - this.rows) : true; }
	isFirstPage(): boolean { return this.tapeCharts ? this.first === 0 : true; }

	get Statuses() {
		return this.statuses;
	}

	getStatusName(tapeChart: any) {
		if (tapeChart?.status) {
			const status = this.statuses.find((e: any) => e.value == tapeChart.status);
			return status.name;
		}
		else {
			return '';
		}
	}
	
	reloadPage() {
		window.location.reload();
	}
}
